import React, { useState } from "react";
import CreateNewButton from "../CreateNewButton";
import ExportZonesButton from "./ExportZones";
import CopyButton from "../CopyButton";
import DataProvider from "../../DataProvider.js";
import { EditCustomRedirectButton, ShowFromOrg } from "./OrgButtons.js";
import RemoveButton from "../RemoveButton";

import RenameTextField from "../RenameTextField";
import zoneAlerts from "../../defaults/ZoneAlerts";
import BulkUploadZones from "../BulkUploadZones";

import "./OrgPopup.css";

import useUser from "../../hooks/useUser";

import { ZoneSwitch } from "./OrgSwitches.js";

const OrgZonePopup = (props) => {
  const orgid = props.id;
  const [zones, setZones] = useState(null);
  const [sortDirection, setSortDirection] = useState("ASC");
  const user = useUser();

  function toggleSort(type) {
    let direction;
    sortDirection === "ASC" ? (direction = "DESC") : (direction = "ASC");
    setSortDirection(direction);
    getData("", "", "", { field: type, order: direction });
  }

  let divs = [
    <div class="pop-row no-hover">
      <div
        class="pop-row-section pop-row-section-header"
        onClick={() => toggleSort("name")}
      >
        Name
      </div>
      <div
        class="pop-row-section pop-row-section-header"
        onClick={() => toggleSort("customID")}
      >
        Zone ID
      </div>
      <div
        class="pop-row-section pop-row-section-header"
        onClick={() => toggleSort("serialNo")}
      >
        Serial #
      </div>
      {user.role === "super-admin" && (
        <div
          class="pop-row-section pop-row-section-header"
          onClick={() => toggleSort("id")}
        >
          Alarm.com ID
        </div>
      )}
      <div
        class="pop-row-section pop-row-section-header"
        onClick={() => toggleSort("message_prefix")}
      >
        Message Type
      </div>
      <div class="pop-row-section pop-row-section-header">ALERTS ON / OFF</div>
      <div class="pop-row-section pop-row-section-header"></div>
      <div class="pop-row-section pop-row-section-header"></div>
      {user.role === "super-admin" && (
        <div class="pop-row-section pop-row-section-header"></div>
      )}
    </div>,
  ];
  const getData = async (filterZoneName, filterZoneID, filterAlarmID, sort) => {
    const data = await DataProvider.getList("zones", {
      pagination: { page: 1, perPage: 10000000000 },
      sort: sort,
      filter: {
        OrganizationId: orgid,
        name: filterZoneName,
        customID: filterZoneID,
        filterAlarmID: filterAlarmID,
      },
    });
    setZones([...data.data]);
  };
  if (zones === null) getData("", "", "", { field: "customID", order: "ASC" });
  else
    for (let zone of zones) {
      divs.push(
        <div class="pop-row" style={{ minWidth: "730px" }}>
          <div class="pop-row-section">{zone.name}</div>
          <div class="pop-row-section">{zone.customID}</div>
          <div class="pop-row-section">{zone.serialNo}</div>
          {user.role === "super-admin" && (
            <div class="pop-row-section">
              <CopyButton label="Alarm.com ID">
                <div>{`#SOS#${zone.id}`}</div>
              </CopyButton>
            </div>
          )}
          <div class="pop-row-section">
            <RenameTextField
              label="Message Type"
              record={zone}
              source="message_prefix"
              types={zoneAlerts}
              target="name"
            />
          </div>
          <div class="pop-row-section">
            <ZoneSwitch zoneprops={zone} label={"ALERTS ON/OFF"} />
          </div>
          <div class="pop-row-section">
            <ShowFromOrg
              record={zone}
              orgID={orgid}
              buttonTitle="Show"
              path="zones"
              search_id="organization_id"
            />
          </div>
          <div class="pop-row-section">
            <EditCustomRedirectButton
              edittype="zones"
              ddorgid={props.id}
              record={zone}
              redirectorigin="Organizations"
              path="zones"
            />
          </div>
          {user.role === "super-admin" && (
            <RemoveButton
              iszone={true}
              orgrecord={props.record}
              id={zone.id}
              targetresource="zone_ids"
              handleupdate={handleUpdate}
              name={zone.name}
            />
          )}
        </div>
      );
    }

  function handleUpdate() {
    getData("", "", "", { field: "customID", order: "ASC" });
  }

  return (
    <div>
      <div class="bg-overlay" onClick={props.onclickoutside} />
      <div class="org-popup">
        <div class="org-popup-title">
          Zones
          <div>
            {user.role === "super-admin" && <ExportZonesButton {...props} />}
            {user.role === "super-admin" && (
              <CreateNewButton
                orgID={parseInt(orgid)}
                search_id="organization_id"
                redirectorigin="Organizations"
                path="zones"
              />
            )}
          </div>
        </div>
        {user.role === "super-admin" && <BulkUploadZones {...props} />}
        <div class="org-popup-sub-title">Organization's Associated Zones</div>
        <div class="popup-filters">
          <input
            class="popup-filter"
            type="text"
            name="name"
            placeholder="Filter Zone Name"
            onChange={(e) =>
              getData(e.target.value, "", "", {
                field: "customID",
                order: "ASC",
              })
            }
          />
          <input
            class="popup-filter"
            type="text"
            name="id"
            placeholder="Filter Zone ID"
            onChange={(e) =>
              getData("", e.target.value, "", {
                field: "customID",
                order: "ASC",
              })
            }
          />
          {user.role === "super-admin" && (
            <input
              class="popup-filter"
              type="text"
              name="alarm"
              placeholder="Filter Alarm.com ID"
              onChange={(e) =>
                getData("", "", e.target.value, {
                  field: "customID",
                  order: "ASC",
                })
              }
            />
          )}
        </div>
        <div class="popup-table">{divs}</div>
      </div>
    </div>
  );
};

export default OrgZonePopup;
